export const ROLES = {
    ADMIN: 'admin'
};